module.exports = __webpack_public_path__ + "media/images/popup_close-e483477dbb2580e9f7991bb110d489ac.png";